module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/76cd1038baa3bca0d71a60cd1020438e.png";